'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { showPriceSubscriptionForm } from '../../../app/CardAnnouncement/actions';

class PriceSubscriptionButton extends React.Component {
  constructor (props) {
    super(props);

    this.dispatch = props.dispatch;
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick () {
    const {dealType, realtyType, realtyId} = this.props;

    this.dispatch(showPriceSubscriptionForm({
      dealType,
      realtyType,
      realtyId
    }));
  }

  render () {
    if (this.props.isIconBtn) {
      return (
        <div className='price-subscription is-icon'>
          <div onClick={this.handleClick} data-tip data-for='tip-price-subscription' className='icon icon-letter' />
        </div>
      );
    }

    return (
      <div className='price-subscription'>
        <button
          onClick={this.handleClick}
          className='btn-base'
        >СЛЕДИТЬ ЗА ЦЕНОЙ</button>
      </div>
    );
  }
}

PriceSubscriptionButton.propTypes = {
  isIconBtn: PropTypes.bool,
  dealType: PropTypes.string.isRequired,
  realtyType: PropTypes.string.isRequired,
  realtyId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  dispatch: PropTypes.func.isRequired
};

export default connect()(PriceSubscriptionButton);



// WEBPACK FOOTER //
// ./src/ui/Controls/Subscriptions/PriceSubscriptionButton.jsx